import React, {useEffect, useState} from "react"
import {formatDateDataGrid} from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_TIME_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsBondsGuarantorsTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({count: 0, next: null, previous: null})

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const {body} = response
            const {results, count, next, previous} = body
            const list = results.map((obj, index) => ({...obj, id: index}))
            setPagination({count: count, next: next, previous: previous})
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "IDEmissao": null,
            "ISIN": null,
            "ISIN144a": null,
            "IDTipoEmissao": null,
            "NumeroEmissaoRus": null,
            "NumeroEmissaoEng": null,
            "NumeroEmissaoPol": null,
            "NumeroEmissaoIta": null,
            "DocumentoEmissaoRus": null,
            "DocumentoEmissaoEng": null,
            "DocumentoEmissaoPol": null,
            "DocumentoEmissaoIta": null,
            "IDPaisEmitente": null,
            "IDRegiaoEmitente": null,
            "IDSubregiaoEmitente": null,
            "IDEmitente": null,
            "NomeEmitenteRus": null,
            "NomeEmitenteEng": null,
            "NomeEmitentePol": null,
            "NomeEmitenteIta": null,
            "IDStatus": null,
            "NomeStatusRus": null,
            "NomeStatusEng": null,
            "NomeStatusPol": null,
            "NomeStatusIta": null,
            "HoraAtualizacao": dayjs().format(DATE_TIME_FORMAT_SHOW),
            "IDGarantidor": null,
            "InnGarantidor": null,
            "LeiGarantidor": null,
            "NomeGarantidorRus": null,
            "NomeGarantidorEng": null,
            "NomeGarantidorPol": null,
            "NomeGarantidorIta": null,
            "IDPaisGarantidor": null,
            "NomePaisGarantidorRus": null,
            "NomePaisGarantidorEng": null,
            "NomePaisGarantidorPol": null,
            "NomePaisGarantidorIta": null,
            "IDRegiaoPaisGarantidor": null,
            "IDSubregiaoPaisGarantidor": null,
            "IDTipoEmitente": null,
            "TipoEmitenteGarantidor": null,
            "MostrarRu": null,
            "MercadosNegociacaoAtual": null,
            "created_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
            "src_updated_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            IDEmissao,
            ISIN,
            ISIN144a,
            IDTipoEmissao,
            NumeroEmissaoRus,
            NumeroEmissaoEng,
            NumeroEmissaoPol,
            NumeroEmissaoIta,
            DocumentoEmissaoRus,
            DocumentoEmissaoEng,
            DocumentoEmissaoPol,
            DocumentoEmissaoIta,
            IDPaisEmitente,
            IDRegiaoEmitente,
            IDSubregiaoEmitente,
            IDEmitente,
            NomeEmitenteRus,
            NomeEmitenteEng,
            NomeEmitentePol,
            NomeEmitenteIta,
            IDStatus,
            NomeStatusRus,
            NomeStatusEng,
            NomeStatusPol,
            NomeStatusIta,
            HoraAtualizacao,
            IDGarantidor,
            InnGarantidor,
            LeiGarantidor,
            NomeGarantidorRus,
            NomeGarantidorEng,
            NomeGarantidorPol,
            NomeGarantidorIta,
            IDPaisGarantidor,
            NomePaisGarantidorRus,
            NomePaisGarantidorEng,
            NomePaisGarantidorPol,
            NomePaisGarantidorIta,
            IDRegiaoPaisGarantidor,
            IDSubregiaoPaisGarantidor,
            IDTipoEmitente,
            TipoEmitenteGarantidor,
            MostrarRu,
            MercadosNegociacaoAtual,
            created_at,
            src_updated_at
        } = newRow

        const body = {
            "IDEmissao": IDEmissao,
            "ISIN": ISIN,
            "ISIN144a": ISIN144a,
            "IDTipoEmissao": IDTipoEmissao,
            "NumeroEmissaoRus": NumeroEmissaoRus,
            "NumeroEmissaoEng": NumeroEmissaoEng,
            "NumeroEmissaoPol": NumeroEmissaoPol,
            "NumeroEmissaoIta": NumeroEmissaoIta,
            "DocumentoEmissaoRus": DocumentoEmissaoRus,
            "DocumentoEmissaoEng": DocumentoEmissaoEng,
            "DocumentoEmissaoPol": DocumentoEmissaoPol,
            "DocumentoEmissaoIta": DocumentoEmissaoIta,
            "IDPaisEmitente": IDPaisEmitente,
            "IDRegiaoEmitente": IDRegiaoEmitente,
            "IDSubregiaoEmitente": IDSubregiaoEmitente,
            "IDEmitente": IDEmitente,
            "NomeEmitenteRus": NomeEmitenteRus,
            "NomeEmitenteEng": NomeEmitenteEng,
            "NomeEmitentePol": NomeEmitentePol,
            "NomeEmitenteIta": NomeEmitenteIta,
            "IDStatus": IDStatus,
            "NomeStatusRus": NomeStatusRus,
            "NomeStatusEng": NomeStatusEng,
            "NomeStatusPol": NomeStatusPol,
            "NomeStatusIta": NomeStatusIta,
            "HoraAtualizacao": HoraAtualizacao,
            "IDGarantidor": IDGarantidor,
            "InnGarantidor": InnGarantidor,
            "LeiGarantidor": LeiGarantidor,
            "NomeGarantidorRus": NomeGarantidorRus,
            "NomeGarantidorEng": NomeGarantidorEng,
            "NomeGarantidorPol": NomeGarantidorPol,
            "NomeGarantidorIta": NomeGarantidorIta,
            "IDPaisGarantidor": IDPaisGarantidor,
            "NomePaisGarantidorRus": NomePaisGarantidorRus,
            "NomePaisGarantidorEng": NomePaisGarantidorEng,
            "NomePaisGarantidorPol": NomePaisGarantidorPol,
            "NomePaisGarantidorIta": NomePaisGarantidorIta,
            "IDRegiaoPaisGarantidor": IDRegiaoPaisGarantidor,
            "IDSubregiaoPaisGarantidor": IDSubregiaoPaisGarantidor,
            "IDTipoEmitente": IDTipoEmitente,
            "TipoEmitenteGarantidor": TipoEmitenteGarantidor,
            "MostrarRu": MostrarRu,
            "MercadosNegociacaoAtual": MercadosNegociacaoAtual,
            "created_at": created_at,
            "src_updated_at": src_updated_at
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const {ID} = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const {body} = response
            const {results, count, next, previous} = body
            const list = results.map((obj) => ({...obj, id: obj.ID}))
            setPagination({count: count, next: next, previous: previous})
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const {body} = response
            const {results, count, previous, next} = body
            const list = results.map((obj) => ({...obj, id: obj.ID}))

            setPagination({count: count, next: next, previous: previous})
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN144a',
            headerName: 'ISIN144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDTipoEmissao',
            headerName: 'IDTipoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NumeroEmissaoRus',
            headerName: 'NumeroEmissaoRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NumeroEmissaoEng',
            headerName: 'NumeroEmissaoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NumeroEmissaoPol',
            headerName: 'NumeroEmissaoPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NumeroEmissaoIta',
            headerName: 'NumeroEmissaoIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoEmissaoRus',
            headerName: 'DocumentoEmissaoRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoEmissaoEng',
            headerName: 'DocumentoEmissaoEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoEmissaoPol',
            headerName: 'DocumentoEmissaoPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DocumentoEmissaoIta',
            headerName: 'DocumentoEmissaoIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDPaisEmitente',
            headerName: 'IDPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDRegiaoEmitente',
            headerName: 'IDRegiaoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDSubregiaoEmitente',
            headerName: 'IDSubregiaoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDEmitente',
            headerName: 'IDEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeEmitenteRus',
            headerName: 'NomeEmitenteRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeEmitenteEng',
            headerName: 'NomeEmitenteEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeEmitentePol',
            headerName: 'NomeEmitentePol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeEmitenteIta',
            headerName: 'NomeEmitenteIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDStatus',
            headerName: 'IDStatus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomeStatusRus',
            headerName: 'NomeStatusRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeStatusEng',
            headerName: 'NomeStatusEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeStatusPol',
            headerName: 'NomeStatusPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeStatusIta',
            headerName: 'NomeStatusIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'HoraAtualizacao',
            headerName: 'HoraAtualizacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW): '',
        },
        {
            field: 'IDGarantidor',
            headerName: 'IDGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'InnGarantidor',
            headerName: 'InnGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'LeiGarantidor',
            headerName: 'LeiGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeGarantidorRus',
            headerName: 'NomeGarantidorRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeGarantidorEng',
            headerName: 'NomeGarantidorEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeGarantidorPol',
            headerName: 'NomeGarantidorPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomeGarantidorIta',
            headerName: 'NomeGarantidorIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDPaisGarantidor',
            headerName: 'IDPaisGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NomePaisGarantidorRus',
            headerName: 'NomePaisGarantidorRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomePaisGarantidorEng',
            headerName: 'NomePaisGarantidorEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomePaisGarantidorPol',
            headerName: 'NomePaisGarantidorPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'NomePaisGarantidorIta',
            headerName: 'NomePaisGarantidorIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDRegiaoPaisGarantidor',
            headerName: 'IDRegiaoPaisGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDSubregiaoPaisGarantidor',
            headerName: 'IDSubregiaoPaisGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoEmitente',
            headerName: 'IDTipoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoEmitenteGarantidor',
            headerName: 'TipoEmitenteGarantidor',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarRu',
            headerName: 'MostrarRu',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MercadosNegociacaoAtual',
            headerName: 'MercadosNegociacaoAtual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'created_at',
            headerName: 'created_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW): '',
        },
        {
            field: 'src_updated_at',
            headerName: 'src_updated_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW): '',
        },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true}/>
        </div>
    )
}

ParameterCBondsBondsGuarantorsTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsBondsGuarantorsTable